export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN'
export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_COMMERCIAL = 'ROLE_COMMERCIAL'
export const ROLE_FINANCE = 'ROLE_FINANCE'
export const ROLE_MARKETING = 'ROLE_MARKETING'
export const ROLE_OPERATIONS = 'ROLE_OPERATIONS'
export const ROLE_TRADE_SUPPORT = 'ROLE_TRADE_SUPPORT'

export const PROMOTIONS_IMPORT_ROLES = [ROLE_SUPER_ADMIN, ROLE_COMMERCIAL]
export const LANDING_PAGES_IMPORT_ROLES = [ROLE_SUPER_ADMIN, ROLE_MARKETING]
export const USER_IMPORT_ROLES = [ROLE_SUPER_ADMIN]
export const USER_EXPORT_ROLES = [ROLE_SUPER_ADMIN]
export const PRODUCT_IMPORT_ROLES = [ROLE_SUPER_ADMIN, ROLE_COMMERCIAL]
export const ATTRIBUTE_IMPORT_ROLES = [ROLE_SUPER_ADMIN, ROLE_COMMERCIAL]
export const LOCATIONS_IMPORT_ROLES = [ROLE_SUPER_ADMIN]
export const REDIRECTS_IMPORT_ROLES = [ROLE_SUPER_ADMIN]